module.exports = __webpack_public_path__ + "img/icon_tg.5fc030cc.svg";